import { render, staticRenderFns } from "./RerNoteList.vue?vue&type=template&id=08bc499e&scoped=true"
import script from "./RerNoteList.vue?vue&type=script&lang=js"
export * from "./RerNoteList.vue?vue&type=script&lang=js"
import style0 from "./RerNoteList.vue?vue&type=style&index=0&id=08bc499e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bc499e",
  null
  
)

export default component.exports